/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import Form, { Values } from 'react-trazo-forms'
import withCongress, { ComponentProps } from '../../../../providers/Congress/withCongress'
import withWizardProps, { WizardProps } from '../../../../wrappers/withWizardParams'
import withReservation, { ReservationProps } from '../../../../providers/Reservation/withReservation'
import { RouterItem } from '../../../../config/router.config'
import { getNextWizardPath } from '../../../../helpers/wizard'
import { message, Modal } from 'antd'
import { saveRegistration, getReservation, purchase } from '../../../../requests/inscription'
import DetailResolver from '../../../../components/Resolvers/DetailResolver'
import LoaderWrapper from '../../../../components/Utils/LoaderWrapper'
import Section from '../../../../components/Section/Section'
import Row from '../../../../components/Form/Row'
import Col from '../../../../components/Form/Col'
import Label from '../../../../components/Form/Label'
import Button from '../../../../components/Utils/Button'
import { flowRight } from 'lodash'
import {
  informationFields,
  informationInitialValues,
  informationValidationSchema,
} from '../../forms/wizard/information'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps {
  step: RouterItem;
  nextStep: RouterItem;
}

interface FormValues {
  Country: any,
  Day: any,
  Email: any,
  FirstName: any,
  LastName: any,
  Gender: any,
  IsChilean: any,
  Month: any,
  JobTitle: any,
  CompanyName: any,
  Passport: any,
  PhoneNumber: any,
  RUT: any,
  Commune: any,
  Year: any,
  LengthOfService: any,
  PriceUUID: any,
}

interface State {
  values: FormValues,
  isValid: boolean,
  isLoading: boolean,
}

class Information extends React.Component<Props, State> {
  state: State = {
    values: {
      Country: 'Chile',
      Day: null,
      Email: null,
      Gender: null,
      IsChilean: null,
      FirstName: null,
      LastName: null,
      Month: null,
      JobTitle: null,
      CompanyName: null,
      Passport: null,
      PhoneNumber: null,
      RUT: null,
      Commune: null,
      Year: null,
      LengthOfService: null,
      PriceUUID: null
    },
    isValid: true,
    isLoading: false,
  }

  handleFormSubmit = () => {
    const { values } = this.state
    const { wizard } = this.props

    this.setState({ isLoading: true })

    const copyOfValues = { ...values }
    delete copyOfValues.Day
    delete copyOfValues.Month
    delete copyOfValues.Year

    saveRegistration({ id: wizard.token }, {
      Information: copyOfValues,
    })
      .then(async (resp: any) => {
        this.handleSuccess()
      })
      .catch((resp: any) => {
        if (resp.message.includes('duplicate key value') && resp.message.includes('RUT')) {
          Modal.error({
            title: 'Se ha producido un problema:',
            content: 'Ya existe una inscripción con este RUT',
          })
        } else message.error(resp.message)
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleSuccess = async() => {
    const { history, wizard, congress, step } = this.props

    try {
      var reservation = await getReservation({ id: wizard.token })

      if(!reservation.Data.IsConfirmed){
        var data = {
          'FinishingSource': 'forms',
          'PaymentMethod': 'None',
        }
        const sendPurchase = await purchase({ id: wizard.token }, data )
      }
      const nextPath = getNextWizardPath(wizard.token, congress.Slug, step.slug)
      history.push(nextPath)
    } catch(e) {
      console.log('error : ',e)
    } finally {
      this.setState({ isLoading: false })
    }

    
  }

  handleResolve = (data: any, callback: () => void) => {
    const { congress, history, wizard, step } = this.props

    if (data.Data.IsStepOneCommitted) {
      const nextPath = getNextWizardPath(wizard.token, congress.Slug, step.slug)
      history.push(nextPath)
    }

    callback()
  }

  onChange = (values: any, isValid: any) => {

    let newValues = values

    if (values.Day && values.Month && values.Year) {
      const birthDate = new Date(values.Year, values.Month, values.Day).toISOString()
      newValues['BirthDate'] = birthDate
    }

    if (values.LengthOfService) {
      newValues['LengthOfService'] = parseInt(values.LengthOfService)
    }

    this.setState({ values: newValues, isValid })
  }

  render () {
    const { reservation } = this.props
    console.log('data', reservation.data)
    return (
      <DetailResolver
        requestFunction={() => getReservation({ id: reservation.data.UUID })}
        render={this.renderContent}
        onResolve={this.handleResolve}
      />
    )
  }

  renderContent = (data: any) => {
    const { isLoading } = this.state

    var newBirthDate = {}
    if(data.Data.BirthDate){
      var month = data.Data.BirthDate.substr(5,2)-1
      newBirthDate = {
        'Year': data.Data.BirthDate.substr(0,4),
        'Month': (month < 10 ? '0' : '') + month,
        'Day': data.Data.BirthDate.substr(8,2).toString(),
      }
    }

    return (
      <LoaderWrapper isLoading={isLoading}>
        <Form
          initialValues={informationInitialValues(data.Data, newBirthDate)}
          fields={informationFields()}
          validationSchema={informationValidationSchema}
          onChange={(values: Values, isValid: boolean) => this.onChange(values, isValid)}
        >
          {this.renderForm(data.Data)}
        </Form>
      </LoaderWrapper>
    )
  }

  renderForm = (data: any) => () => {
    const { values } = this.state
    return (
      <React.Fragment>
        <Section>
          <h2>Datos Personales</h2>

          <Row gutter={32} m={15}>
            <Col md={12}>
              <div>Nombre Completo:</div>
              <h3 style={{ fontWeight: 600, color: '#4b5c6b' }}>{data.FirstName} {data.LastName}</h3>
            </Col>
            <Col md={12}>
              <div>Correo Electrónico Principal:</div>
              <h3 style={{ fontWeight: 600, color: '#4b5c6b' }}>{data.Email}</h3>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Label>
                <Form.Field.Label name="IsChilean"/>
              </Label>
            </Col>
            <Col md={12}>
              <Form.Field name="IsChilean" hideLabel inline/>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="Country"/>
              <Form.Field name="Commune"/>
            </Col>
            <Col md={{ span: 12 }}>
              <Form.Field name="Passport"/>
              <Form.Field name="RUT"/>
            </Col>
          </Row>
        </Section>

        <Section>
          <div style={{ marginBottom: 8 }}>Fecha de nacimiento</div>
          <Row gutter={32}>
            <Col xs={8} md={4}>
              <Form.Field name="Day"/>
            </Col>
            <Col xs={8} md={4}>
              <Form.Field name="Month"/>
            </Col>
            <Col xs={8} md={4}>
              <Form.Field name="Year"/>
            </Col>
            <Col md={12}>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="PhoneNumber"/>
            </Col>
            <Col md={{ span: 12 }}>
              <Form.Field name="Gender"/>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="JobTitle"/>
            </Col>
            <Col md={12}>
              <Form.Field name="LengthOfService"/>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={24}>
              <Form.Field name="CompanyName"/>
            </Col>
          </Row>
        </Section>


        {this.renderActionButton()}
      </React.Fragment>
    )
  }

  renderActionButton () {
    const { isValid, isLoading, values } = this.state
    const { congress, nextStep } = this.props

    var message = 'Algunas respuestas son inválidas o no están completas'
    if (values.IsChilean && values.Commune === undefined) {
      message = 'Por favor seleccione su comuna'
    } else if (values.IsChilean && values.RUT === undefined) {
      message = 'Por favor ingrese su Rut'
    } else if (!values.IsChilean && values.Country === undefined) {
      message = 'Por favor seleccione su país'
    } else if (!values.IsChilean && values.Passport === undefined) {
      message = 'Por favor ingrese su pasaporte'
    } else if (values.Day === undefined) {
      message = 'Por favor seleccione su día de nacimiento'
    } else if (values.Month === undefined) {
      message = 'Por favor seleccione su mes de nacimiento'
    } else if (values.Year === undefined) {
      message = 'Por favor seleccione su año de nacimiento'
    } else if (values.PhoneNumber === undefined) {
      message = 'Por favor ingrese su número de celular'
    } else if (values.Gender === '') {
      message = 'Por favor seleccione su género'
    } else if (values.JobTitle === undefined || values.JobTitle === null) {
      message = 'Por favor seleccione su rol en la empresa'
    } else if (values.LengthOfService === undefined || values.LengthOfService === null) {
      message = 'Por favor ingrese sus años de antigüedad'
    } else if (values.CompanyName === undefined || values.CompanyName === '') {
      message = 'Por favor ingrese nombre de su empresa'
    }

    return (
      <Section align="center">
        <Button
          disabledMessage={message}
          color={congress.PrimaryColor}
          disabled={!isValid || isLoading}
          onClick={this.handleFormSubmit}>
          {nextStep.nextButtonLabel}
        </Button>
      </Section>
    )
  }
}

export default flowRight([withCongress, withWizardProps, withReservation])(Information)
